import { Link } from '@mui/material';
import React from 'react';

type Props = {
  onClearClicked: () => void;
  clearLabel?: string;
};

export const ClearLink: React.FC<Props> = ({ onClearClicked, clearLabel }) => {
  return (
    <Link
      component="button"
      type="button"
      onClick={onClearClicked}
      sx={{ cursor: 'pointer' }}
    >
      Clear {clearLabel ? clearLabel : 'all'}
    </Link>
  );
};
